import { createContext } from "react";
 
export const expertContext = createContext({
    toggel : true,
    setToggel : ()=>{},
    category : [],
    setCategory : ()=>{},
    tab : 1,
    setTab : () => {},
    estate : {},
    setEstate : ()=>{},
    attributes : [],
    setAttributes : ()=>{},
    attributes2 : [],
    setAttributes2 : ()=>{},
    attributes3 : [],
    setAttributes3 : ()=>{},
    totalPrice : 0,
    setTotalPrice : () => {},
    areaInfo : {},
    setAreaInfo : ()=> {},
    imgName : "",
     setImgName: ()=>{},
     description : "", 
     setDescription : ()=>{},
     page : "",
     setPage: ()=>{},
     exInfo : {},
     setExInfo : ()=>{},
     total1 : 0, 
     setTotal1 : ()=>{},
     total2 : 0, 
     setTotal2: ()=>{},
     total3: 0, 
     setTotal3: ()=>{},

})